import { useQuery } from '@gogame/query';

import { loadChart } from '../sources/Chart';
import { getChartByIndex } from './queryKeyFactory';

export const useLoadChart = ({ ...params }, { enabled, index }) => {
  return useQuery(
    getChartByIndex(index)({ ...params }),
    (_, { signal }) => loadChart(params, { signal }),
    {
      enabled,
      keepPreviousData: enabled,
    }
  );
};
